import { getScrollTop, setBannerHeight, stickyHeader } from './helpers';

import toggleCookieBanner from './cookie-banner';
/* Hero Fader ------------------------------------------------------------*/

function fade() {
  const heroHeight = document.querySelector('.hero').clientHeight;
  const winPosition = getScrollTop();
  const winPositionPercent = (winPosition / heroHeight);
  const fadeValue = (0 + winPositionPercent / 2.5);
  const fader = document.getElementById('fader');
  if (fader) {
    fader.style.opacity = fadeValue;
  }
}

function toggleMegaMenu() {
  const navLinks = document.querySelectorAll('.header__nav__left .nav-link');
  if (navLinks) {
    navLinks.forEach((navItem) => {
      navItem.addEventListener('mouseover', function handleMouseOver() {
        navLinks.forEach((el) => {
          el.style.borderColor = 'transparent';// eslint-disable-line
        });
        this.style.borderColor = '#2dccd2';
        setTimeout(() => {
          document.querySelector('header').classList.add('mega-menu-pop-up');
          document.body.classList.add('overlay');
        }, 200);

        const targetContent = document.querySelector('.mega-menu.visible');
        if (targetContent) {
          targetContent.classList.remove('visible');
        }
        this.parentElement.querySelector('.mega-menu').classList.add('visible');
      });
    });
  }
  document.querySelector('header').addEventListener('mouseleave', () => {
    navLinks.forEach((el) => {
      el.style.borderColor = null; // eslint-disable-line
    });
    setTimeout(() => {
      document.querySelector('header').classList.remove('mega-menu-pop-up');
      document.body.classList.remove('overlay');
    }, 300);
  });
}

/* Pop-up menu */
function toggleMobileMenu() {
  document.querySelector('header .burger-menu').addEventListener('click', () => {
    document.querySelector('header').classList.toggle('menu-pop-up');
    if (document.querySelector('header').classList.contains('menu-pop-up')) {
      document.body.classList.add('overflow-hidden');
    } else { document.body.classList.remove('overflow-hidden'); }
  });
}


function animateLogo() {
  const logo = document.querySelector('.logo');
  if (logo) {
    setTimeout(() => {
      logo.classList.remove('logo-animate');
    }, 2000);
  }
}

function moveChatWidget() {
  const main = document.querySelector('main');
  if (window.pageYOffset >= document.documentElement.offsetHeight - 60) {
    main.classList.add('dock-chatwidget');
  } else if (document.querySelector('main.dock-chatwidget')) main.classList.remove('dock-chatwidget');
}

window.addEventListener('load', () => {
  setBannerHeight();
  stickyHeader();
  animateLogo();
  toggleCookieBanner();
  if (window.innerWidth > 1120) toggleMegaMenu();
  else toggleMobileMenu();
  if (window.innerWidth > 580) moveChatWidget();
});

window.addEventListener('scroll', () => {
  stickyHeader();

  if (document.querySelector('.hero')) {
    fade();
  }
  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});

window.addEventListener('resize', () => {
  setBannerHeight();
  stickyHeader();
  if (window.innerWidth > 1024) {
    document.querySelector('header').classList.remove('menu-pop-up');
    document.body.classList.remove('overflow-hidden');
  }

  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});
